import React from 'react';
import { FaCheckCircle, FaArrowLeft } from 'react-icons/fa';

export const PlanCard = ({ name, price, limit, features, highlight = false }) => (
  <div
    className={`bg-white rounded-[32px] p-6 md:p-8 shadow-md border ${highlight ? "border-blue-500 shadow-blue-100 ring-2 ring-blue-500 ring-opacity-30 relative scale-100 lg:scale-105 z-10" : "border-gray-100 mt-0 lg:mt-6"} flex flex-col h-full transform transition-all hover:shadow-xl`}
  >
    {highlight && (
      <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gradient-to-r from-blue-600 to-cyan-500 text-white font-black text-[10px] md:text-xs py-1.5 md:py-2 px-6 rounded-full uppercase tracking-[0.2em] shadow-lg">
        Recomendado
      </div>
    )}
    <div className="text-center mb-6 border-b border-gray-100 pb-6">
      <h3
        className={`text-sm md:text-base font-black ${highlight ? "text-blue-600" : "text-gray-400"} uppercase tracking-[0.2em] mb-4`}
      >
        {name}
      </h3>
      <div className="flex items-start justify-center gap-1 mb-4 h-16">
        <span className="text-2xl md:text-3xl font-bold text-blue-500 mt-2">
          $
        </span>
        <span className="text-5xl md:text-6xl font-black text-blue-900 tracking-tighter">
          {price}
        </span>
      </div>
      <p className="text-xs font-bold bg-blue-50 text-blue-700 px-3 py-1.5 rounded-full inline-block mt-2">
        Suscripción Anual
      </p>
    </div>
    <div className="flex-grow">
      <div className="bg-gray-50 border border-gray-100 rounded-2xl py-3 px-4 mb-6 text-center">
        <p className="text-sm font-black text-gray-800">Hasta {limit} Socios</p>
      </div>
      <ul className="space-y-4 text-sm md:text-base text-gray-600 font-medium text-left px-0">
        {features.map((feature, idx) => (
          <li key={idx} className="flex items-start gap-4">
            <div
              className={`mt-1 p-1 rounded-full ${highlight ? "bg-blue-100 text-blue-600" : "bg-gray-100 text-gray-400"}`}
            >
              <FaCheckCircle className="text-[10px]" />
            </div>
            <span className="leading-snug">{feature}</span>
          </li>
        ))}
      </ul>
    </div>
    <button
      onClick={() =>
        window.open(
          `https://wa.me/593983930386?text=${encodeURIComponent(`Hola, estoy interesado en el Plan ${name} de AquaGestión.`)}`,
          "_blank",
        )
      }
      className={`mt-10 w-full py-4 rounded-2xl font-black transition-all active:scale-95 flex justify-center items-center gap-2 ${highlight ? "bg-blue-600 text-white hover:bg-blue-700 shadow-xl shadow-blue-200/50" : "bg-blue-50/50 border-2 border-transparent hover:border-blue-100 text-blue-600 hover:bg-blue-50"}`}
    >
      Lo quiero <FaArrowLeft className="rotate-180 opacity-50 text-xs" />
    </button>
  </div>
);
